"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = {
    isLoading: false,
    result: null,
    error: null,
    wasSuccessful: false,
};
//# sourceMappingURL=constants.js.map